module.exports = __webpack_public_path__ + "img/music-file.3db6012b.png";